import axios from "axios";
import isDev from "../server";
import { message } from "antd";
const serverUrl = isDev();

// export const addcategory = newCategoryData => dispatch => {
//   dispatch({
//     type: "ADD_CATEGORY",
//     payload: newCategoryData
//   });
// };

// export const addBanner = newBannerData => dispatch => {
//   dispatch({
//     type: "ADD_BANNER",
//     payload: newBannerData
//   });
// };

export const getAllLabelsData = (dispatch) => {
    axios.post(`${serverUrl}/${JSON.parse(localStorage.getItem("countryData")).database_identifier}/multi-language/get-language-data-admin/`, {
    },
        {
            headers: {
                "Content-Type": "application/json",
                Authorization: `JWT ${localStorage.getItem("token")}`
            }
        }).then(response => {
            if (response.data.status === 200) {
                dispatch({
                    type: "GET_ALL_LABELS",
                    value: response.data
                });
            }
            else {
                message.error("Something went wrong!");
            }
        });
};
